import React from 'react'
import {
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import VendNumber from 'vend-number'

import { RoundedNumber, HandlePaymentFunction } from '../../CashPaymentModal'
import { Header } from './Header'
import { Actions } from './Actions'

interface PayProps {
  amountToPay: RoundedNumber
  closeWithoutPayment: () => void
  currencySymbol: string
  handlePayment: HandlePaymentFunction
  rounding: VendNumber
}

export const Pay: React.FC<PayProps> = ({
  amountToPay,
  closeWithoutPayment,
  currencySymbol,
  handlePayment,
  rounding,
}) => (
  <Modal size="medium" dismissable onClose={() => closeWithoutPayment()}>
    <ModalHeader>
      <Header amountToPay={amountToPay} />
    </ModalHeader>
    <ModalContent>
      <span className="vd-text-heading">Amount given by customer</span>
    </ModalContent>
    <ModalActions>
      <Actions
        rounding={rounding}
        amountToPay={amountToPay}
        handlePayment={handlePayment}
        currencySymbol={currencySymbol}
      />
    </ModalActions>
  </Modal>
)
